// extracted by mini-css-extract-plugin
module.exports = {"absoluteContainer":"menu_absoluteContainer__28BEw","hidden":"menu_hidden__LcUtc","menu":"menu_menu__3JpjD","menuUp":"menu_menuUp__1jQ5U","menuOption":"menu_menuOption__2XvnJ"};